import { render, staticRenderFns } from "./CustomerIcon.vue?vue&type=template&id=d6b4255e&scoped=true&"
import script from "./CustomerIcon.vue?vue&type=script&lang=ts&"
export * from "./CustomerIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerIcon.vue?vue&type=style&index=0&id=d6b4255e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b4255e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
